module.exports = __webpack_public_path__ + "static/media/github.0555bfb7.svg";